<template>
<div>
    <!-- STOCK-2875 Faz 9: Arşivlenmiş Avukatlık Ücretleri + "Daily Work'e Taşı" -->
    <vue-good-table id="lawMatterBudgetReportArchivedAttorneyFeeTable" ref="lawMatterBudgetReportArchivedAttorneyFeeTable" :columns="columns" :rows="rows" styleClass="vgt-table condensed tableSize" :search-options="{
                enabled: true,
                externalQuery: searchTerm
              }" :select-options="{ enabled: false }" theme="my-theme">
        <div slot="emptystate">
            {{ $t('dataTable.data_not_found') }}
        </div>
        <template slot="table-column" slot-scope="props">
            <span v-if="props.column.field === 'dailyworkDate'" class="text-nowrap">{{ $t('lawMatterBudgetReport.date') }}</span>
            <span v-else-if="props.column.field === 'code'" class="text-nowrap">{{ $t('lawMatterBudgetReport.code') }}</span>
            <span v-else-if="props.column.field === 'description'" class="text-nowrap">{{ $t('lawMatterBudgetReport.description') }}</span>
            <span v-else-if="props.column.field === 'currencyCode'" class="text-nowrap">{{ $t('lawMatterBudgetReport.currency_code') }}</span>
            <span v-else-if="props.column.field === 'price'" class="text-nowrap">{{ $t('lawMatterBudgetReport.amount') }}</span>
            <span v-else-if="props.column.field === 'process'"></span>
        </template>
        <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field === 'price'">
                <span>{{ $formatMoneyTr(props.row.price) }}</span>
            </span>
            <span v-else-if="props.column.field === 'description'">
                <span class="wh-clamp-2" v-b-tooltip.hover="{ title: props.row.description, customClass: 'wh-tooltip' }">{{ props.row.description }}</span>
            </span>
            <span v-else-if="props.column.field === 'process'">
                <b-button size="sm" variant="outline-primary" @click="moveToDailywork(props.row)">
                    {{ $t('lawMatterBudgetReport.move_to_dailywork') }}
                </b-button>
            </span>
        </template>
    </vue-good-table>
</div>
</template>

<script>
export default {
    props: {
        // Taşıma sonrası bütçe raporunu yeniden yükleyen fonksiyon (form.showInfo).
        reload: { type: Function }
    },
    data() {
        return {
            columns: [
                { label: this.$t('lawMatterBudgetReport.date'), field: `dailyworkDate`, formatFn: this.$formatFn },
                { label: this.$t('lawMatterBudgetReport.code'), field: `code` },
                { label: this.$t('lawMatterBudgetReport.description'), field: `description` },
                { label: this.$t('lawMatterBudgetReport.currency_code'), field: `currencyCode` },
                { label: this.$t('lawMatterBudgetReport.amount'), field: `price`, tdClass: 'text-right', thClass: 'text-right' },
                { label: '', field: 'process', sortable: false, width: '12em', tdClass: 'text-right', thClass: 'text-right' },
            ],
            rows: [],
            searchTerm: '',
        }
    },
    methods: {
        // reload-safe: her beslemede sıfırla (taşıma sonrası tekrar çağrılıyor).
        setValues(values) {
            this.rows = []
            if (values) values.forEach(element => this.rows.push(element))
        },
        async moveToDailywork(row) {
            const result = await this.$PrivateConfirm(
                this.$t('lawMatterBudgetReport.move_confirm_title'),
                this.$t('lawMatterBudgetReport.move_confirm_question'),
                'warning',
                this.$t('lawMatterBudgetReport.move_to_dailywork'),
                this.$t('alerts.not_delete_button')
            )
            if (result.value) {
                const payload = { data: { id: row.id }, controller: { name: 'LawDailywork', actionName: 'UnarchiveDailyWork' } }
                const response = await this.$store.dispatch('moduleAuth/customService', payload)
                if (response.data.resultStatus == true) {
                    this.$SaveAlert()
                    if (this.reload) this.reload()
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            }
        }
    },
}
</script>

<style lang="scss">
.tableSize {
    font-size: 13px !important;
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
    table-layout: auto;
}
</style>
